import { AuditData } from "./AuditData";
import { Timestamp } from "firebase/firestore";

export class InstallationStep {

    active: boolean = false;
    code: string = '';
    name: string | null = null;
    test: any = {};
    initialized = false;
    preconditions: any = {};
    allowSkip: boolean = false;
    dateStarted: Timestamp | null = null;
    dateVerified: Timestamp | null = null;
    dateFailed: Timestamp | null = null;
    failDescription: string | null = null;
    preconditionsDateVerified: Timestamp | null = null;
    
    constructor(data?: Partial<InstallationStep>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}

export class Installation {
    
    id: string | null = null;
    deviceId: string | null = null;
    audit: AuditData | null = null;
    steps: InstallationStep[] = [];
    dateStarted: Timestamp | null = null;
    dateCompleted: Timestamp | null = null;
    dateFailed: Timestamp | null = null;
    failDescription: string | null = null;
    deviceReplaced: boolean = false;
    
    constructor(data?: Partial<Installation>, settings?: { disableWireTamperChecklistSteps?: string }) {
        if (data) {
            Object.assign(this, data);
        }
        if (!this.audit) {
            this.audit = new AuditData();
        }
        if (!this.steps?.length) {
            this.steps = [
                new InstallationStep({
                    active: true,
                    code: 'AutoLockDisable',
                    name: 'Auto-Lock Disable',
                }),
                new InstallationStep({
                    active: true,
                    code: 'Gps',
                    name: 'GPS',
                }),
                new InstallationStep({
                    active: true,
                    code: 'RemoteLock',
                    name: 'Remote Lock',
                }),
                new InstallationStep({
                    active: true,
                    code: 'RemoteUnlock',
                    name: 'Remote Unlock',
                }),
                new InstallationStep({
                    active: true,
                    code: 'IgnitionLock',
                    name: 'Ignition-Lock',
                }),
                new InstallationStep({
                    active: true,
                    code: 'MovementTamper',
                    name: 'Movement Tamper',
                }),
                new InstallationStep({
                    active: true,
                    code: 'StarterLock',
                    name: 'Starter-Lock',
                }),
                new InstallationStep({
                    active: true,
                    code: 'BatteryDisconnect',
                    name: 'Battery Disconnect',
                }),
                new InstallationStep({
                    active: true,
                    code: 'BatteryConnect',
                    name: 'Battery Connect',
                }),
                new InstallationStep({
                    active: settings?.disableWireTamperChecklistSteps !== 'true',
                    code: 'WireTamper1Activation',
                    name: 'Wire Tamper Activation',
                    allowSkip: true
                }),
                new InstallationStep({
                    active: settings?.disableWireTamperChecklistSteps !== 'true',
                    code: 'WireTamper1Deactivation',
                    name: 'Wire Tamper Deactivation',
                }),
                new InstallationStep({
                    active: true,
                    code: 'RemotePanic',
                    name: 'Remote Panic',
                }),
                new InstallationStep({
                    active: true,
                    code: 'PanicButton',
                    name: 'Panic Button',
                }),
                new InstallationStep({
                    active: true,
                    code: 'FuelCut',
                    name: 'Fuel Cut',
                }),
                new InstallationStep({
                    active: true,
                    code: 'AutoLockEnable',
                    name: 'Auto-Lock Enable',
                })
            ].filter(x => x.active);
        }
    }
}